import Spaceship        from 'foundations/layout/spaceship.jpg';
import {Button}         from 'foundations/button/button';
import {useTranslation} from 'foundations/i18n/i18n';

export function EapSignupCta() {
    const {t} = useTranslation();
    return (
        <div className={'py-[200px] bg-bottom bg-cover object-center'} style={{
            backgroundImage: `linear-gradient( rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.8) ), url(${Spaceship.src})`
        }}>
            <div className={'text-center max-w-lg m-auto'}>
                <h1 className={'block font-black text-3xl lg:text-5xl mb-2 text-white !leading-tight'}>{t('Blast through engineering headaches')}</h1>
                <p className={'block text-xl text-white mb-8'}>{t('See your new favourite developer platform in action')}</p>
                <Button href={'https://app.withglimpse.com/signup'}>{t('Signup for free')}</Button>
            </div>
        </div>
    );
}